var XPortal = XPortal || {};
XPortal.DropdownBtns = (function () {
    var dropdownBtns = {};

    dropdownBtns.init = function () {
        const $body = $('body');
        this.dropdownHover.init();
        this.notificationExpander.init();
        this.gridButtons.init($body);
        this.gridButtons.initEvents($body);
    };

    dropdownBtns.openDotsIfPanelInside = function ($panel) {
        var $dots = $panel.closest('.dots');
        if ($dots.length && !$dots.hasClass('open')) {
            $dots.find('.dropdown-toggle').dropdown('toggle');
        }

        var $serviceDots = $panel.closest('.grid-parent').find('.k-grid-header .dots');
        if ($serviceDots.length) {
            $serviceDots.removeClass('show');
            $serviceDots.find('.dropdown-menu').removeClass('show');
        }
    };

    dropdownBtns.notificationExpander = {
        init: function () {
            $(document).off('click.xpandlist').on('click.xpandlist', '.xpand-list > *:first-child', function (e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    $cnt = $this.parent();

                if (!$cnt.hasClass('opened')) {
                    $cnt.addClass('opened');
                    $this.nextAll().stop().slideDown(300);
                }
                else {
                    $cnt.removeClass('opened');
                    $this.nextAll().stop().slideUp(300);
                }
            });
        }
    };

    dropdownBtns.gridButtons = {
        checkTimeOut: null,
        init: function ($wrapper) {
            if (!$wrapper.find('.dropdown.dropdown-hover.desktop-inline:not(.grid-buttons-inited)').length) {
                return;
            }

            var $buttons = $wrapper.find('.dropdown.dropdown-hover.desktop-inline');
            if ($buttons.parents('.grid-action-header').length > 0) {
                setTimeout(function () {
                    dropdownBtns.gridButtons.check($wrapper);
                }, 500);
            } else {
                dropdownBtns.gridButtons.check($wrapper);
            }

            $wrapper.find('.dropdown.dots:not(.grid-service-dd-dots):not(.dropdown-dots-inited)').on('hide.bs.dropdown hide.dots.dropdown', function () {
                var $list = $(this).find('.columns-list-wrapper, .filters-list-wrapper, .grid-calendar-buttons-wrapper');
                if (!$list.length)
                    return;

                $list.removeClass('open');
                setTimeout(function () {
                    $list.removeClass('right');
                }, 300);
            }).addClass('dropdown-dots-inited');

            const isListViewCase = $wrapper.find('.entity-cvactions').length;

            if(isListViewCase) {
                requestAnimationFrame(function () {
                    dropdownBtns.gridButtons.check($wrapper);
                });
            }
        },
        initEvents: function ($wrapper) {
            $(window).on('resize.gridbuttonseventgroup', function () { dropdownBtns.gridButtons.checkWithTimeout($wrapper); })
                .on('orientationchange.gridbuttonseventgroup', function () { dropdownBtns.gridButtons.checkWithTimeout($wrapper); });

            $(document).on('click', '.grid-service-dd-dots .dropdown-toggle', function () {
                $('.grid-service-dd-dots.show').not($(this).closest('.grid-service-dd-dots')).removeClass('show');
                $('.dropdown-menu-in-table.show').not($(this).next()).removeClass('show');
            });
        },
        checkWithTimeout: function ($wrapper) {
            clearTimeout(dropdownBtns.gridButtons.checkTimeOut);
            dropdownBtns.gridButtons.checkTimeOut = setTimeout(function () {
                dropdownBtns.gridButtons.check($wrapper);
            }, 100);
        },
        check: function ($wrapper, contentWidth) {
            let $elems;
            let $dotsElems;
            if (contentWidth > 0) {
                $elems = $wrapper.find('.dropdown.dropdown-hover.desktop-inline');
                $dotsElems = $wrapper.find('.dropdown.dropdown-hover.dots');
            }
            else {
                $elems = $wrapper.find('.dropdown.dropdown-hover.desktop-inline').not('.grid-header-resize .dropdown.dropdown-hover.desktop-inline');
                $dotsElems = $wrapper.find('.dropdown.dropdown-hover.dots').not('.grid-header-resize .dropdown.dropdown-hover.dots');
            }

            const measured = new Map();

            $elems.each(function () {
                const $this = $(this);
                const $elemWrapper = $this.closest('.input-group-flex');
                const $dots = $this.next();
                const $container = $this.closest('.grid-action-header, .entity-list, .k-grid');
                const key = $container[0] || $elemWrapper[0] || this;
                let fit = measured.get(key);

                // Initial setup
                $dots.addClass('d-none');

                if (!fit) {
                    $this.addClass('d-none');
                    let allowedWidth = contentWidth || $elemWrapper.width();
                    if ($this.closest('.grid-action-header').length > 0) {
                        allowedWidth = Math.max(allowedWidth, 100); // Ensure a minimum width of 100 for grid header actions
                    }
                    fit = { allowedWidth: allowedWidth, numberOfButtons: null };
                    measured.set(key, fit);
                }

                // Reinitialize buttons
                $this.removeClass('d-none');
                dropdownBtns.gridButtons.moveButtons($this, $dots, fit.allowedWidth, fit);
                $this.addClass('grid-buttons-inited');

                // Remove opacity class after initialization
                $elemWrapper.removeClass('opacity-0');
            });

            $dotsElems.each(function () {
                const $this = $(this);
                const $dropdownMenu = $this.find('.dropdown-menu');
                const $dropdownToggle = $this.find('.dropdown-toggle');

                // Check if all dropdown menu children have the 'd-none' class
                const allHidden = $dropdownMenu.children().toArray().every(child => child.classList.contains('d-none'));

                // Toggle visibility of the dropdown button
                $dropdownToggle.toggleClass('d-none', allHidden);
            });
        },
        moveButtons: function (wrapper, dots, allowedWidth, fit) {
            const $tagsContainer = wrapper.parents('.edit-btns-wrapper').find('.current-tags');
            const $menu = wrapper.find('.dropdown-menu:first');
            const dotsBtn = wrapper.next('.dropdown.dropdown-hover.dots');
            let totalWidth = 0, numberOfButtons = 0;

            const isHidden = ($item) =>
                $item.hasClass('d-none') ||
                ($item.hasClass('hide-for-view-mode') && $item.closest('.d-mode-viewonly').length > 0);

            const updateAllHiddenState = ($container, $target) => {
                const $items = $container.children();
                const allHidden = $items.length > 0 && $items.filter((ix, x) => !isHidden($(x))).length === 0;
                $target.toggleClass('all-actions-hidden', allHidden);
            };

            const $buttons = $menu.children();
            if ($buttons.length === 1 && $buttons.first().hasClass('hide-change-view-action')) {
                $buttons.addClass('d-none');
                $buttons.closest('.grid-actions-col').addClass('d-none');
                return;
            }

            // Force collapse: when the tile action group opts in (XGridContentViewActions.ForceCollapse),
            // push every command into the dots menu no matter how much space is available.
            if (wrapper.closest('.force-collapse-actions').length) {
                $buttons.not('.lbl-save-state-wrp').addClass('d-none');
                dots.find('.dropdown-menu:first').children().removeClass('d-none');
                dotsBtn.removeClass('d-none');
                wrapper.parents('.grid-action-header').addClass('dots-menu-visible');
                return;
            }

            if (wrapper.closest('.grid-header-actions').length) {
                const $dotsButtons = dots.find('.dropdown-menu:first').children();
                const isSkipped = ($btn) => $btn.is('.hide-change-view-action, .lbl-save-state-wrp') ||
                    $btn.is('.d-mode-viewonly .hide-for-view-mode');
                const measure = ($el) => {
                    const wasHidden = $el.hasClass('d-none');
                    if (wasHidden) $el.removeClass('d-none').css('visibility', 'hidden');
                    const width = $el.outerWidth(true) || 0;
                    if (wasHidden) $el.addClass('d-none').css('visibility', '');
                    return width;
                };

                const widths = $buttons.toArray().map(x => isSkipped($(x)) ? 0 : measure($(x)));
                const totalButtonsWidth = widths.reduce((sum, w) => sum + w, 0);
                const shown = widths.map(() => true);

                if (totalButtonsWidth > allowedWidth) {
                    const dotsWidth = measure(dotsBtn);
                    let usedWidth = dotsWidth;
                    let overflow = false;
                    $buttons.each(function (ix) {
                        if (isSkipped($(this))) return;
                        if (!overflow && usedWidth + widths[ix] <= allowedWidth) {
                            usedWidth += widths[ix];
                        } else {
                            overflow = true;
                            shown[ix] = false;
                        }
                    });
                }

                $buttons.each(function (ix) {
                    const $btn = $(this);
                    if (!$btn.hasClass('lbl-save-state-wrp')) {
                        $btn.toggleClass('d-none', !shown[ix]);
                    }
                    $dotsButtons.eq(ix).toggleClass('d-none', shown[ix]);
                });

                const hasOverflow = shown.some(x => !x);
                dotsBtn.toggleClass('d-none', !hasOverflow);
                wrapper.parents('.grid-action-header').toggleClass('dots-menu-visible', hasOverflow);

                if ($tagsContainer.length) {
                    this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
                }
                return;
            }

            // Ensure checkbox and save button positions
            const $checkbox = $buttons.find('.row-checkbox');
            if ($checkbox.length) {
                const $checkboxBtn = $checkbox.closest('.dropdown-item');
                $checkboxBtn.addClass('checkbox-wrp').prependTo($menu);
            }

            const $saveBtn = $buttons.filter('.save-button-right-wrp');
            if ($saveBtn.length) {
                $saveBtn.prependTo($menu);
            }

            const isServiceSell = wrapper.hasClass('grid-service-dd-line');
            const isCompactMode = isServiceSell && wrapper.closest('.input-group-flex[data-state="compact-mode"]').length;

            //Mobile view

            const isMobile = window.innerWidth < 576;
            const isTablet = window.innerWidth >= 576 && window.innerWidth < 992;

            if (isMobile) {
                const $dotsMenu = dots.find('.dropdown-menu:first');
                const $dotsButtons = $dotsMenu.children();

                const $realButtons = $buttons.not('.hide-change-view-action')
                                            .not('.checkbox-wrp')
                                            .not('.save-button-right-wrp')
                                            .not('.lbl-save-state-wrp');

                const $pinnedButtons = $saveBtn.filter((ix, x) => !$(x).is('.d-mode-viewonly .hide-for-view-mode'));
                const maxVisibleButtons = 2;

                const totalButtons = $realButtons.length + $pinnedButtons.length;

                if (totalButtons <= maxVisibleButtons) {
                    let twoButtonsWidth = 0;
                    $realButtons.add($pinnedButtons).each(function() {
                        const $btn = $(this);
                        const wasHidden = $btn.hasClass('d-none');
                        if (wasHidden) {
                            $btn.removeClass('d-none').css('visibility', 'hidden');
                        }
                        twoButtonsWidth += $btn.outerWidth(true);
                        if (wasHidden) {
                            $btn.addClass('d-none').css('visibility', '');
                        }
                    });

                    if (twoButtonsWidth <= allowedWidth) {
                        $buttons.not('.lbl-save-state-wrp').removeClass('d-none');
                        $dotsButtons.addClass('d-none');
                        dotsBtn.addClass('d-none');
                        wrapper.parents('.grid-action-header').removeClass('dots-menu-visible');

                        if ($tagsContainer.length) {
                            this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
                        }
                        return;
                    }
                }

                const visibleCount = Math.max(0, maxVisibleButtons - 1 - $pinnedButtons.length);

                $buttons.not('.lbl-save-state-wrp').addClass('d-none');
                $pinnedButtons.removeClass('d-none');
                $realButtons.slice(0, visibleCount).removeClass('d-none');

                const $fullWidthBtn = $realButtons.add($pinnedButtons).filter('.btn_full_width');

                $dotsButtons.addClass('d-none');
                const remainingDots = visibleCount - ($checkbox.length ? 1 : 0);

                $dotsButtons.not('.save-button-right-wrp').slice(Math.max(0, remainingDots)).removeClass('d-none');

                const hasOverflow = $realButtons.length > visibleCount;
                dotsBtn.toggleClass('d-none', !hasOverflow);
                wrapper.parents('.grid-action-header').toggleClass('dots-menu-visible', hasOverflow);

                const $visibleButtons = $realButtons.not('.d-none').add($pinnedButtons).add(dotsBtn.not('.d-none'));
                let visibleButtonsWidth = 0;

                $visibleButtons.each(function() {
                    const $btn = $(this);
                    let width;

                    if ($btn.is($fullWidthBtn)) {
                        const hadClass = $btn.hasClass('ignore_full_width');
                        if (hadClass) $btn.removeClass('ignore_full_width');
                        width = $btn.outerWidth(true);
                        if (hadClass) $btn.addClass('ignore_full_width');
                    } else {
                        width = $btn.outerWidth(true);
                    }

                    visibleButtonsWidth += width;
                });

                const $editBtnsWrapper = $realButtons.closest('.edit-btns');
                let fullWidthBudget = allowedWidth;

                const $header = $editBtnsWrapper.closest('.edit-btns-wrapper_header');
                if ($header.length) {
                    const titleEl = $header.children('.with-header-items').find('h1')[0];
                    const headerWidth = $header.width();
                    const titleMinWidth = titleEl ? Math.min(titleEl.scrollWidth, headerWidth * 0.4) : 0;
                    const editBtnsSpacing = $editBtnsWrapper.outerWidth(true) - $editBtnsWrapper.width();
                    fullWidthBudget = Math.max(allowedWidth, headerWidth - titleMinWidth - editBtnsSpacing);
                }

                if ($editBtnsWrapper.length && visibleButtonsWidth > fullWidthBudget) {
                    $fullWidthBtn.addClass('ignore_full_width');
                } else {
                    $fullWidthBtn.removeClass('ignore_full_width');
                }

                if ($tagsContainer.length) {
                    this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
                }
                return;
            }

            if (isTablet) {
                const $dotsMenu = dots.find('.dropdown-menu:first');
                const $dotsButtons = $dotsMenu.children();

                const $realButtons = $buttons.not('.hide-change-view-action')
                                            .not('.checkbox-wrp')
                                            .not('.save-button-right-wrp')
                                            .not('.lbl-save-state-wrp');

                const $pinnedButtons = $saveBtn.filter((ix, x) => !$(x).is('.d-mode-viewonly .hide-for-view-mode'));

                const totalButtons = $realButtons.length + $pinnedButtons.length;

                let visibleCount = 2;

                //Search and buttons in section with attachments

                const $section = wrapper.closest('.xsection:has(.dropzone-container), .xsection.col-4:has(.grid-action-header), .xsection.col-3:has(.grid-action-header)');

                const isListViewCaseTop = $buttons.closest('.entity-cvactions.entity-cvactions_top').length;

                if(isListViewCaseTop) {
                    let dotsBtnWidth = dotsBtn.find('.dropdown-toggle').outerWidth();;
                    allowedWidth = dotsBtnWidth ? allowedWidth - dotsBtnWidth : allowedWidth;
                }

                if ($section.length) {
                    $section.find('.grid-action-header').addClass('attachments-action');

                    const btnsWrapperWidth = $section.find('.grid-actions-col').width();
                    const dropDownDotsWidth = $section.find('.dropdown.dots').width();
                    const gridActionWrapper = $section.find('.grid-actions-wrp');

                    if (allowedWidth < btnsWrapperWidth + dropDownDotsWidth) {
                        visibleCount = 1;
                        gridActionWrapper.addClass('to-wrap');
                    } else if (allowedWidth < btnsWrapperWidth) {
                        visibleCount = 0;
                    }
                }

                //

                if (totalButtons <= visibleCount) {
                    $buttons.not('.lbl-save-state-wrp').removeClass('d-none');
                    $dotsButtons.addClass('d-none');
                    dotsBtn.addClass('d-none');
                    wrapper.parents('.grid-action-header').removeClass('dots-menu-visible');

                    if ($tagsContainer.length) {
                        this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
                    }
                    return;
                }

                const realVisibleCount = Math.max(0, visibleCount - $pinnedButtons.length);
                const $toShow = $realButtons.slice(0, realVisibleCount);
                let shownWidth = 0;
                $toShow.add($pinnedButtons).each(function() {
                    const $btn = $(this);
                    const wasHidden = $btn.hasClass('d-none');

                    if (wasHidden) {
                        $btn.removeClass('d-none').css('visibility', 'hidden');
                    }

                    shownWidth += $btn.outerWidth(true);

                    if (wasHidden) {
                        $btn.addClass('d-none').css('visibility', '');
                    }
                });

                const shownCount = shownWidth > allowedWidth
                    ? Math.max(0, 1 - $pinnedButtons.length)
                    : realVisibleCount;

                $buttons.not('.lbl-save-state-wrp').addClass('d-none');
                $pinnedButtons.removeClass('d-none');
                $realButtons.slice(0, shownCount).removeClass('d-none');

                $dotsButtons.addClass('d-none');
                const remainingDots = shownCount - ($checkbox.length ? 1 : 0);
                $dotsButtons.not('.save-button-right-wrp').slice(Math.max(0, remainingDots)).removeClass('d-none');

                const hasOverflow = $realButtons.length > shownCount;
                dotsBtn.toggleClass('d-none', !hasOverflow);
                wrapper.parents('.grid-action-header').toggleClass('dots-menu-visible', hasOverflow);

                if ($tagsContainer.length) {
                    this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
                }
                return;
            }

            //End of mobile view

            //Adjust the width only if the dot button is necessary
            if (dotsBtn && dotsBtn.length) {
                dotsBtn.addClass('d-none');
            }
            $buttons.removeClass('d-none');

            const excludedSelectors = ['.hide-change-view-action', '.d-mode-viewonly .hide-for-view-mode'];
            const isExcludedFromWidth = ($btn) => excludedSelectors.some(sel => $btn.is(sel));
            const $realButtons = $buttons.not('.d-mode-viewonly .hide-for-view-mode');

            if (fit && fit.numberOfButtons != null) {
                numberOfButtons = Math.min(fit.numberOfButtons, $realButtons.length);
            } else {
                // First determine if all the buttons will fit
                $buttons.each(function () {
                    const $btn = $(this);
                    const btnWidth = isExcludedFromWidth($btn) ? 0 : $btn.outerWidth(true);
                    totalWidth += btnWidth;
                });

                const needsOverflow = totalWidth > allowedWidth;

                // Commands on tiles

                // Then find out how we are going to split the dot bttns and menu btts
                if (needsOverflow) {
                    dotsBtn.removeClass('d-none');
                    const dotsWidth = dotsBtn.outerWidth(true);
                    allowedWidth -= dotsWidth;
                    dotsBtn.addClass('d-none');

                    totalWidth = 0;
                    $realButtons.each(function () {
                        const $btn = $(this);
                        const btnWidth = isExcludedFromWidth($btn) ? 0 : $btn.outerWidth(true);
                        totalWidth += btnWidth;
                        if (totalWidth <= allowedWidth) {
                            numberOfButtons++;
                        }
                    });
                } else {
                    numberOfButtons = $realButtons.length;
                }

                if (fit) fit.numberOfButtons = numberOfButtons;
            }

            const $dotsMenu = dots.find('.dropdown-menu:first');
            const $dotsButtons = $dotsMenu.children();

            // Ensure consistency in checkbox state in dots menu
            if ($checkbox.length) {
                $dotsButtons.find('.row-checkbox').closest('.dropdown-item').addClass('checkbox-wrp');
            }

            const isListViewCase = $buttons.closest('.entity-cvactions').length;

            if (isListViewCase) {
                numberOfButtons = Math.min(numberOfButtons, 2 + ($checkbox.length ? 1 : 0));
            }
            // Hide all buttons initially 
            $realButtons.not('.lbl-save-state-wrp').addClass('d-none');
            $dotsButtons.addClass('d-none');

            // Show buttons that fit and hide the rest
            $realButtons.slice(0, Math.max(0, numberOfButtons)).removeClass('d-none');
            let remainingDots = numberOfButtons - ($checkbox.length ? 1 : 0);

            if (isListViewCase) {
                remainingDots = Math.min(remainingDots, 2);
                updateAllHiddenState($menu, dotsBtn);
            }

            $dotsButtons.slice(Math.max(0, remainingDots)).removeClass('d-none');

            // Check if all dots menu buttons are effectively hidden
            const allHidden = $dotsButtons.toArray().every(button => {
                const $button = $(button);
                return $button.hasClass('d-none') ||
                    $button.hasClass('hide-change-view-action') ||
                    ($button.hasClass('lbl-save-state-wrp') && $button.find('.lbl-save-state').hasClass('d-none'));
            });

            // Toggle dots visibility
            if ((isCompactMode || numberOfButtons < $realButtons.length) &&
                dotsMenuHasVisibleItems(dots) && !allHidden) {
                dots.removeClass('d-none');
                wrapper.parents('.grid-action-header').addClass('dots-menu-visible');
            } else {
                dots.addClass('d-none');
                wrapper.parents('.grid-action-header').removeClass('dots-menu-visible');
            }

            if (isListViewCase) {
                const $actionsCol = wrapper.closest('.entity-cvactions');
                const isTwoButtonsOnly = $realButtons.length === 2 &&
                    numberOfButtons === 2 &&
                    dots.hasClass('d-none');
                $actionsCol.toggleClass('two-actions-only', isTwoButtonsOnly);
            }

            // Handle tags if present
            if ($tagsContainer.length) {
                this.handleAppliedTags($tagsContainer, $buttons, $dotsButtons);
            }

            // Helper to check if dots menu has visible items
            function dotsMenuHasVisibleItems(dots) {
                return dots.find('.dropdown-item:not(.checkbox-wrp):not(.save-button-right-wrp):not(.lbl-save-state-wrp)').length > 0;
            }
        },
        handleAppliedTags: function ($tagsContainer, $buttons, $dotsButtons) {
            const isTagsApplied = $tagsContainer.find('.tag-item').length > 0;
            const $parent = $('.edit-btns-wrapper_header');
            const $headerItems = $parent.find('.with-header-items');
            const $header = $headerItems.find('.page-title-wrp');
            const $btnsWrap = $parent.find('.dropdown.dropdown-hover.desktop-inline');
            const $btns = $btnsWrap.find('li.dropdown-item');
            const $dotsWrap = $parent.find('.dropdown.dropdown-hover.dots');
            const dotsMap = {};

            $parent.addClass('with-tags');
            $dotsButtons.each(function () {
                const key = $(this).data("key");
                dotsMap[key] = $(this);
            });

            if ($tagsContainer.length >= 2) {
                $headerItems.addClass('has-multiple-tags');
            }
            if (isTagsApplied) {
                // When tags are applied
                $btns.addClass('d-none');
                $headerItems.addClass('tags-applied');

                const freeSpace = $parent.width() - $header.width() - $tagsContainer.width();
                // let showedBtnsNumber = 6;
                let totalWidth = 0;
                let showedBtnsNumber = 0;

                $btns.each(function (index) {
                    const $button = $(this);
                    $button.removeClass('d-none');
                    const buttonWidth = $button.outerWidth(true);
                    $button.addClass('d-none');

                    if (totalWidth + buttonWidth <= freeSpace) {
                        totalWidth += buttonWidth;
                        showedBtnsNumber++;

                        $button.removeClass('d-none');
                        const dkey = $button.attr("data-key");
                        if (dkey && dotsMap[dkey]) dotsMap[dkey].addClass('d-none');
                    }
                });

                // Hide dots if all buttons fit
                if (showedBtnsNumber === $btns.length) {
                    $dotsWrap.addClass('d-none');
                } else {
                    $dotsWrap.removeClass('d-none');
                }

            } else {
                // When tags are not applied
                $headerItems.removeClass('tags-applied');
                const freeSpace = $parent.width() - $header.width() - $tagsContainer.width();
                let totalWidth = 0;
                let showedBtns = 0;

                $btns.removeClass('d-none'); // Reset visibility

                // Adjust buttons based on available space
                $btns.each(function (index) {
                    const $button = $(this);
                    const buttonWidth = $button.outerWidth(true);
                    const dkey = $button.attr("data-key");

                    if (totalWidth + buttonWidth <= freeSpace) {
                        totalWidth += buttonWidth;
                        showedBtns++;
                        $button.removeClass('d-none'); // Show button
                        if (dkey && dotsMap[dkey]) dotsMap[dkey].addClass('d-none');
                    } else {
                        $button.addClass('d-none'); // Hide button
                        if (dkey && dotsMap[dkey]) dotsMap[dkey].removeClass('d-none');
                    }
                });

                // Hide dots if all buttons fit
                if (showedBtns === $btns.length) {
                    $dotsWrap.addClass('d-none');
                } else {
                    $dotsWrap.removeClass('d-none');
                }
            }
        },

        adjustMenuPosition: function ($dotsBtn) {
            if (!$dotsBtn.closest('.k-grid').length) return;
            var dotsOffset = $dotsBtn.offset();
            var $menu = $dotsBtn.next();
            $menu.css({
                'left': dotsOffset.left + 'px',
                'top': (dotsOffset.top + $dotsBtn.outerHeight()) + 'px',
            });
        }
    };

    dropdownBtns.dropdownHover = {
        init: function () {
            var $body = $('body');
            $body.on('click', '.dropdown-submenu > .dropdown-toggle', function (e) {
                var $this = $(this);
                $this.next('ul').add($this.closest('.dropdown-submenu')).toggleClass('show');
                e.stopImmediatePropagation();
                e.preventDefault();
            });

            $body.on('click', '.dropdown-menu:not(.toolbar) .di-content', function () {
                dropdownBtns.dropdownHover.doClick(this);
            });

            $body.on('click', '.dropdown_view-select', function () {
                XPortal.DropdownBtns.gridButtons.checkWithTimeout($('.grid-action-header'));
            });

            $body.on('click', '.dropdown.dots .dropdown-toggle', function (event) {
                event.preventDefault();
                var $parent = $(this).parent();
                $parent.toggleClass('show');
                $parent.find('.dropdown-menu').toggleClass('show');
                dropdownBtns.dropdownHover.fitGridHeaderMenu($parent);
            });

            $body.on('click', '.entity-cvactions .dropdown.dots .dropdown-toggle', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var $toggle = $(this);

                var $existingClone = $toggle.data('dropdownMenuClone');
                var isOpen = $existingClone && $existingClone.data('isOpen');

                $body.find('.dropdown-menu-in-table.dropdown-menu-detached').each(function () {
                    $(this).remove();
                });

                if (isOpen) {
                    $toggle.removeData('dropdownMenuClone');
                    return;
                }

                var $cvactions = $toggle.closest('.entity-cvactions');
                var $parent = $toggle.parent();
                var $originalMenu = $parent.find('.dropdown-menu-in-table');
                if (!$originalMenu.length) return;

                var visibleActionIds = [];
                $cvactions.find('.dropdown.grid-buttons-inited .dropdown-item').not('.d-none').each(function () {
                    visibleActionIds.push($(this).data('uniqueid'));
                });

                var $menu = $originalMenu.clone(true, true);
                $toggle.data('dropdownMenuClone', $menu);

                $menu.find('.dropdown-item').each(function () {
                    var $item = $(this);
                    var uid = $item.data('uniqueid');

                    if (visibleActionIds.indexOf(uid) !== -1) {
                        $item.remove();
                    } else {
                        $item.removeClass('d-none');
                    }
                });

                if (!$menu.find('.dropdown-item').length) {
                    $toggle.removeData('dropdownMenuClone');
                    return;
                }

                var $klistContent = $toggle.closest('.k-listview-content');
                if ($klistContent.css('position') === 'static') {
                    $klistContent.css('position', 'relative');
                }

                $menu.css({ display: 'block', visibility: 'hidden', position: 'absolute' })
                    .addClass('dropdown-menu-detached')
                    .appendTo($klistContent);

                var toggleOffset = $toggle.offset();
                var containerOffset = $klistContent.offset();
                var toggleHeight = $toggle.outerHeight();
                var toggleWidth = $toggle.outerWidth();
                var menuWidth = $menu.outerWidth();
                var menuHeight = $menu.outerHeight();

                var containerWidth = $klistContent.outerWidth();
                var containerHeight = $klistContent.outerHeight();
                var containerRight = containerOffset.left + containerWidth;
                var containerBottom = containerOffset.top + containerHeight;

                var spaceBelow = containerBottom - (toggleOffset.top + toggleHeight);
                var spaceAbove = toggleOffset.top - containerOffset.top;

                var docTop, docLeft;
                var openedToSide = false;

                if (menuHeight <= spaceBelow) {
                    docTop = toggleOffset.top + toggleHeight;
                } else if (menuHeight <= spaceAbove) {
                    docTop = toggleOffset.top - menuHeight;
                } else {
                    openedToSide = true;
                    docTop = toggleOffset.top;
                }

                if (openedToSide) {
                    docLeft = toggleOffset.left + toggleWidth;
                    if (docLeft + menuWidth > containerRight) {
                        var leftCandidate = toggleOffset.left - menuWidth;
                        if (leftCandidate >= containerOffset.left) {
                            docLeft = leftCandidate;
                        } else {
                            docLeft = Math.min(docLeft, containerRight - menuWidth);
                            docLeft = Math.max(docLeft, containerOffset.left + 5);
                        }
                    }
                    if (docTop + menuHeight > containerBottom) {
                        docTop = containerBottom - menuHeight;
                    }
                    if (docTop < containerOffset.top) {
                        docTop = containerOffset.top + 5;
                    }
                } else {
                    if (docLeft === undefined) {
                        docLeft = toggleOffset.left;
                    }
                    if (docLeft + menuWidth > containerRight) {
                        docLeft = toggleOffset.left + toggleWidth - menuWidth;
                    }
                    if (docLeft < containerOffset.left) {
                        docLeft = containerOffset.left + 5;
                    }
                }

                var containerEl = $klistContent[0];
                var top = (docTop - containerOffset.top) + containerEl.scrollTop;
                var left = (docLeft - containerOffset.left) + containerEl.scrollLeft;

                $menu.css({ top: top, left: left, zIndex: 1005, visibility: 'visible' }).data('isOpen', true);
            });

            $body.on('click', function (event) {
                if (!$(event.target).closest('.dropdown-menu-in-table, .dropdown-toggle').length) {
                    $body.find('.dropdown-menu-in-table.dropdown-menu-detached').remove();
                }
            });


            $body.on('click', '[data-role="columnmenu"] .dropdown.dots .dropdown-toggle', function (event) {
                dropdownBtns.gridButtons.adjustMenuPosition($(this));
            });

            $body.on('mouseover', '[data-role="columnmenu"] .dropdown.dots .dropdown-toggle', function (event) {
                dropdownBtns.gridButtons.adjustMenuPosition($(this));
            });

            $body.on('click', function (e) {
                var $target = $(e.target);
                var $subMenu = $target.closest('.dropdown-submenu');
                if (!$subMenu.length) {
                    $('.dropdown-submenu').removeClass('show').find('.dropdown-menu').removeClass('show');
                }

                if ($target.closest('.dropdown.dots').length || $target.closest('.k-animation-container').length) {
                    return;
                }

                var $parent = $('.dropdown.dots');
                $parent.removeClass('show');
                $parent.find('.dropdown-menu').removeClass('show');
                $parent.trigger('hide.dots.dropdown');
            });

            $('header .dropdown').each(function () {
                dropdownBtns.dropdownHover.setHeaderDDPosition(this);
            });

            if (!('ontouchstart' in window)) {
                $('header').on('mouseenter', '.dropdown', function () {
                    dropdownBtns.dropdownHover.setHeaderDDPosition(this);
                });
            }
        },
        fitGridHeaderMenu: function ($dots) {
            const $menu = $dots.children('.dropdown-menu');
            const $header = $dots.closest('.grid-action-header');
            if (!$header.length || !$dots.closest('.grid-header-actions').length) return;
            if (!$menu.hasClass('show')) {
                $menu.css({ left: '', right: '' });
                return;
            }
            const headerRect = $header[0].getBoundingClientRect();
            const dotsRect = $dots[0].getBoundingClientRect();
            const menuWidth = $menu.outerWidth();
            let menuLeft = dotsRect.right - menuWidth;
            menuLeft = Math.min(menuLeft, headerRect.right - menuWidth);
            menuLeft = Math.max(menuLeft, headerRect.left);
            $menu.css({ left: (menuLeft - dotsRect.left) + 'px', right: 'auto' });
        },
        setHeaderDDPosition: function (obj) {
            if ($('.dropdown-toggle', obj).length < 1 || $('.dropdown-menu', obj).length < 1)
                console.warn('temp: Popper cant be initialized - there is no container', { obj, toggle: $('.dropdown-toggle', obj), menu: $('.dropdown-menu', obj) });
            else
                new Popper($('.dropdown-toggle', obj), $('.dropdown-menu', obj), { 'placement': 'bottom-start' });
        },
        doClick: function (item) {
            var $dropDown = $(item).parents('.dropdown');

            if ($dropDown.hasClass('dropdown-changable') && !($(item).hasClass("savesettingsbox"))) {
                var $itemText = $(item).find('.dm-item-text');
                if ($itemText.length) {
                    $dropDown.find('.dropdown-toggle').html($itemText.html());
                }
            }

            if ($dropDown.is('.notifications-dd')) {
                return;
            }

            dropdownBtns.gridButtons.check($dropDown.closest('.input-group-flex'));
        }
    };

    dropdownBtns.changePosition = function (btn) {
        var btnClass = 'dropdown-moved-btn';
        var tdClass = 'dropdown-menu-activated';

        var $oldTd = $('.' + tdClass);
        $oldTd.find('input.row-checkbox').prop('checked', false);
        $('.' + btnClass).removeClass(btnClass);
        $oldTd.removeClass(tdClass);

        var $btn = $(btn);
        $btn.addClass(btnClass);

        var $td = $btn.closest('td.service');
        var $chb = $td.find('input.row-checkbox');

        if (!$chb.is(':checked')) {
            $chb.prop('checked', true);
            $td.addClass(tdClass);
        }

        $('.dropdown-cloned').remove();
        var $selectMenu = $btn.next();

        var notifyAction = $selectMenu.find("a[data-action = 'NotificationSubscription']");
        if (notifyAction.length > 0) { //process conditional dropdown menu commands
            var kgrid = $($btn.closest(".k-grid")).data("kendoGrid");
            var viewId = $btn.closest(".k-grid").get(0).id;
            notifyAction = $selectMenu.find("a[data-action = 'NotificationSubscription']");
            var gridNotifications = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == viewId);
            var currentObj = kgrid.dataItem($btn.closest("tr"));

            if (gridNotifications && currentObj && gridNotifications.assignedNotifications) {
                if (gridNotifications.assignedNotifications.indexOf(currentObj.UniqueId.trim()) > -1) {
                    $(notifyAction).html('');
                    $(notifyAction).append(kgrid.options.commands.notificationsubscription.remicon + '<span class="dm-item-text">' + kgrid.options.commands.notificationsubscription.remtitle + '</span>');
                }
                else {
                    $(notifyAction).html('');
                    $(notifyAction).append(kgrid.options.commands.notificationsubscription.addicon + '<span class="dm-item-text">' + kgrid.options.commands.notificationsubscription.addtitle + '</span>');
                }
            }
        }
        var $selectMenuClone = $selectMenu.clone().removeClass('show').addClass('dropdown-cloned');
        setTimeout(function () {
            $selectMenuClone.appendTo($btn.parents('.k-grid'));
            XPortal.DropdownBtns.calculatePosition();
            $selectMenuClone.show(200);
        }, 10);

        $(window).on('scroll', function () { XPortal.DropdownBtns.calculatePosition(); });
        $(window).on('orientationchange', function () { XPortal.DropdownBtns.calculatePosition(); });
        $(window).on('resize', function () { XPortal.DropdownBtns.calculatePosition(); });

        $(document).on('click', function () {
            $('.dropdown-cloned').slideUp(200);
            setTimeout(function () {
                $('.dropdown-cloned').remove();
            }, 200);
        });

        $('.k-grid-content').on('scroll', function () {
            XPortal.DropdownBtns.calculatePosition();
        });
    };

    dropdownBtns.calculatePosition = function () {
        $selectMenu = $('.dropdown-cloned');

        if (!$selectMenu.length) {
            return;
        }

        var $thisBtn = $('.dropdown-moved-btn');
        if ($thisBtn.length > 0) {
            var $grid = $thisBtn.parents('.k-grid');

            var gridOffset = $grid.offset();
            var gridTop = gridOffset.top;
            var gridLeft = gridOffset.left;

            var ddOffset = $thisBtn.offset();
            var ddTop = ddOffset.top;
            var ddLeft = ddOffset.left;

            var div = ddTop + 25 + $selectMenu.height() * 2 + $(window).scrollTop() + $grid.scrollTop() > gridTop + $grid.height() ? $selectMenu.height() + 50 : 0;

            $selectMenu.css({
                'top': ddTop - gridTop + 25 - div,
                'left': ddLeft - gridLeft
            });
        }
    };

    return dropdownBtns;
}());

$(function () {
    XPortal.DropdownBtns.init();
});